import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText } from '@material-ui/core';

import Container from '../../../../components/Base/Container';
import StylesModelInteractor from '../../../../styles/components/StylesModelInteractor';
import Avatar from '../../../../components/Avatar';

const CategoryItem = ({
  onClick, item, selected,
}) => {
  const classes = StylesModelInteractor();
  return (
    <ListItem
      component="div"
      className={classes.container}
      classes={{
        selected: classes.selected,
      }}
      onClick={() => onClick(item.id)}
      selected={selected}
      button
    >
      <Avatar image={item.image} width={60} height={60} />
      <ListItemText className={classes.content}>
        <Container>
          Category
          {`#${item.id}`}
        </Container>
        <Container className={classes.name}>{item.name.toUpperCase()}</Container>
      </ListItemText>
    </ListItem>
  );
};

CategoryItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
};

export default CategoryItem;
